import { format, isValid } from "date-fns";
import { DateFormat } from "../constants/core-constants";

const padDatePart = (value: number): string => value.toString().padStart(2, "0");
const ISO_DATE_ONLY_REGEX = /^\d{4}-\d{2}-\d{2}$/;
const MM_DD_YYYY_DATE_FORMAT = /^\d{2}\/\d{2}\/\d{4}$/;

export function isDateOnlyString(value: string): boolean {
  return ISO_DATE_ONLY_REGEX.test(value);
}

export function parseDateOnly(value: string): Date {
  const [year, month, day] = value.split("-").map(Number);
  return new Date(year, month - 1, day);
}

export function toLocalDate(value: Date | string | null | undefined): Date | null {
  if (!value) {
    return null;
  }

  if (value instanceof Date) {
    return isValid(value)
      ? new Date(value.getFullYear(), value.getMonth(), value.getDate())
      : null;
  }

  if (isDateOnlyString(value)) {
    return parseDateOnly(value);
  }

  if (MM_DD_YYYY_DATE_FORMAT.test(value)) {
    const [month, day, year] = value.split("/").map(Number);
    return new Date(year, month - 1, day);
  }

  const date = new Date(value);
  return isValid(date)
    ? new Date(date.getFullYear(), date.getMonth(), date.getDate())
    : null;
}

export function formatDateOnly(
  value: Date | string | null | undefined,
  dateFormat: string = DateFormat,
  fallback: string = ""
): string {
  const date = toLocalDate(value);
  return date ? format(date, dateFormat) : fallback;
}

export function toDateOnlyString(value: Date | string | null | undefined): string | null {
  const date = toLocalDate(value);

  if (!date) {
    return null;
  }

  const year = date.getFullYear();
  const month = padDatePart(date.getMonth() + 1);
  const day = padDatePart(date.getDate());

  return `${year}-${month}-${day}`;
}
